import {
  Body,
  Box,
  Field,
  IconButton,
  TextInput,
  useDisclosure,
} from '@hover/blueprint';
import { iEye, iEyeOff, iconCheckmark } from '@hover/icons';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { CustomIcon } from 'src/shared/components';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

interface Criteria {
  uppercase: boolean;
  number: boolean;
  eightCharacters: boolean;
}
const criteriaMapper: { [K in keyof Criteria]: string } = {
  uppercase: 'Uppercase',
  number: '1 number',
  eightCharacters: '8 characters',
};
const PASSWORD_MIN_LENGTH = 8;

export const PasswordInputWithValidation = ({
  setIsInvalid,
}: {
  setIsInvalid: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const t = useTranslate(TranslationNamespace.SHARED);
  const { isOpen: isVisible, onToggle } = useDisclosure();

  const {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    watch,
    // eslint-disable-next-line @typescript-eslint/unbound-method
    register,
    formState: { touched },
  } = useFormContext();
  const [criteria, setCriteria] = useState<Criteria>({
    uppercase: false,
    number: false,
    eightCharacters: false,
  });
  const password = (watch('password') as string) ?? '';
  const getIcon = (isValid: any) => {
    if (!isValid || (!password && !touched.password)) return <></>;
    return <CustomIcon color="success.600" icon={iconCheckmark} />;
  };
  useEffect(() => {
    setCriteria({
      uppercase: /[A-Z]/g.test(password),
      number: /[0-9]/g.test(password),
      eightCharacters: password.length >= PASSWORD_MIN_LENGTH,
    });
  }, [password]);
  useEffect(() => {
    setIsInvalid(Object.values(criteria).some(value => !value));
  }, [criteria, setIsInvalid]);

  return (
    <>
      <Field label={t('onboarding.password')} name="password">
        <TextInput
          elementAfter={
            <IconButton
              color="neutral"
              fill="minimal"
              icon={isVisible ? iEyeOff : iEye}
              label={
                isVisible
                  ? t('passwordInput.showPassword')
                  : t('passwordInput.hidePassword')
              }
              onClick={onToggle}
              shape="square"
            />
          }
          label={t('onboarding.password')}
          name="password"
          placeholder=""
          ref={register}
          type={isVisible ? 'text' : 'password'}
        />
      </Field>
      <Box flexDirection="column" rowGap="200">
        {Object.entries(criteria).map(([key, isValid]) => (
          <Box alignItems="center" flexDirection="row" height={300} key={key}>
            {getIcon(isValid)}
            <Body color="neutral.600" m={0}>
              {criteriaMapper[key as keyof Criteria]}
            </Body>
          </Box>
        ))}
      </Box>
    </>
  );
};
